export const createArrayRange = (start: number, end: number) => {
  const resultArray = [...Array(end - start + 1)].map((_, index) => start + index);

  return resultArray;
};
